/* Guide-to-shop measurement uses the existing GA4 tag; no new page views or purchases. */
(() => {
  'use strict';
  if (window.__bkGuideShopping) return;
  window.__bkGuideShopping = true;
  const shopify = window.Shopify;
  if (!shopify) return;
  if (!shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('main a[href]');
    if (!link || event.defaultPrevented || event.button > 0) return;
    if (!shopify.customerPrivacy || !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    if (typeof window.gtag !== 'function') return;
    let destination;
    try { destination = new URL(link.href, window.location.href); } catch (_) { return; }
    if (destination.origin !== window.location.origin) return;
    if (!/^\/(?:en\/|pl\/|de\/)?(?:products|collections)\//.test(destination.pathname)) return;
    window.gtag('event', 'guide_shop_click', {
      send_to: 'G-68LTBQ56JW',
      link_url: destination.origin + destination.pathname,
      link_domain: destination.hostname,
      outbound: false,
      page_location: window.location.origin + window.location.pathname,
      transport_type: 'beacon'
    });
  });
})();
